enum Network {
  Devnet = "devnet",
  Mainnet = "mainnet-beta",
  Testnet = "testnet",
}

export default Network;
